// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__BeUlz","heading":"Styles_heading__3pBsS","content":"Styles_content__1vrch","inner":"Styles_inner__1bvX8"};